// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-dialog-content::ng-deep {
   padding: 0 30px 0px 30px;
}

.signature {
   border: solid 1px #ccc;
   border-radius: 8px;
   margin-bottom: 2em;
   padding: 10px;
   width: 190px;
   min-width: 190px!important;
   height: 70px;
}

.signature img {
   max-height: 50px;
   max-width: 170px;
}

.initial {
   position: relative;
}

.align-left {
   text-align: left;
}

.mg-l-2 {
   margin-left: 2em;
}

.radio-button {
   margin-left: 6px;
}

::ng-deep .mat-button:hover .mat-button-focus-overlay {
   opacity: 0.04 !important;
}

::ng-deep .mat-button-focus-overlay {
   background-color: transparent !important;
}

::ng-deep .enjoy_hint_label {
   opacity: 1 !important;
}

.error {
   text-align: left;
   font-size: 13px;
   color: #d32f2f;
   position: fixed;
}`, "",{"version":3,"sources":["webpack://./src/app/account/update-profile/update-profile.component.css"],"names":[],"mappings":"AAAA;GACG,wBAAwB;AAC3B;;AAEA;GACG,sBAAsB;GACtB,kBAAkB;GAClB,kBAAkB;GAClB,aAAa;GACb,YAAY;GACZ,0BAA0B;GAC1B,YAAY;AACf;;AAEA;GACG,gBAAgB;GAChB,gBAAgB;AACnB;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,wBAAwB;AAC3B;;AAEA;GACG,wCAAwC;AAC3C;;AAEA;GACG,qBAAqB;AACxB;;AAEA;GACG,gBAAgB;GAChB,eAAe;GACf,cAAc;GACd,eAAe;AAClB","sourcesContent":[".mat-dialog-content::ng-deep {\n   padding: 0 30px 0px 30px;\n}\n\n.signature {\n   border: solid 1px #ccc;\n   border-radius: 8px;\n   margin-bottom: 2em;\n   padding: 10px;\n   width: 190px;\n   min-width: 190px!important;\n   height: 70px;\n}\n\n.signature img {\n   max-height: 50px;\n   max-width: 170px;\n}\n\n.initial {\n   position: relative;\n}\n\n.align-left {\n   text-align: left;\n}\n\n.mg-l-2 {\n   margin-left: 2em;\n}\n\n.radio-button {\n   margin-left: 6px;\n}\n\n::ng-deep .mat-button:hover .mat-button-focus-overlay {\n   opacity: 0.04 !important;\n}\n\n::ng-deep .mat-button-focus-overlay {\n   background-color: transparent !important;\n}\n\n::ng-deep .enjoy_hint_label {\n   opacity: 1 !important;\n}\n\n.error {\n   text-align: left;\n   font-size: 13px;\n   color: #d32f2f;\n   position: fixed;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
